const DAY = 'day';
const WEEK = 'week';
const MONTH = 'month';
const YEAR = 'year';
const QUARTER = 'quarter';
const CUSTOM = 'custom';
// NEW PERIODS
const TODAY = 'today';
const YESTERDAY = 'yesterday';
const LAST7DAYS = 'last-7-days';
const LASTWEEK = 'last-week';
const LAST30DAYS = 'last-30-days';
const THISWEEK = 'this-week';
const THISMONTH = 'this-month';
const LASTMONTH = 'last-month';
const THISQUARTER = 'this-quarter';
const LASTQUARTER = 'last-quarter';
const THISYEAR = 'this-year';
const LASTYEAR = 'last-year';

const getItems = t => ([
  {
    id: DAY,
    label: t('day'),
    value: DAY,
  }, {
    id: WEEK,
    label: t('week'),
    value: WEEK,
  }, {
    id: MONTH,
    label: t('month'),
    value: MONTH,
  }, {
    id: CUSTOM,
    label: t('customRange'),
    value: CUSTOM,
  },
  {
    id: QUARTER,
    label: t('quarter'),
    value: QUARTER,
  },
]);

const PERIODARRAY = [
  CUSTOM,
  TODAY,
  YESTERDAY,
  LAST7DAYS,
  LASTWEEK,
  LAST30DAYS,
  LASTMONTH,
  LASTQUARTER,
  LASTYEAR,
  THISMONTH,
  THISQUARTER,
  THISYEAR,
  THISWEEK,
  DAY,
  WEEK,
  MONTH,
  QUARTER,
];

export {
  DAY,
  WEEK,
  MONTH,
  YEAR,
  CUSTOM,
  QUARTER,
  TODAY,
  YESTERDAY,
  LAST7DAYS,
  LASTWEEK,
  LAST30DAYS,
  LASTMONTH,
  LASTQUARTER,
  LASTYEAR,
  THISMONTH,
  THISQUARTER,
  THISYEAR,
  getItems,
  THISWEEK,
  PERIODARRAY,
};
